import { render, staticRenderFns } from "./BagianDalamCard.vue?vue&type=template&id=cf0488ee&"
import script from "./BagianDalamCard.vue?vue&type=script&lang=js&"
export * from "./BagianDalamCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports